import { useCallback, useEffect, useRef, useState } from 'react';

const DEFAULT_DURATION_MS = 1500;

/**
 * Boolean flash state that auto-resets after `durationMs`. Calling `trigger()`
 * (re)starts the timer, so repeated triggers extend the visible window
 * instead of stacking timers.
 */
export function useSavedFlash(durationMs: number = DEFAULT_DURATION_MS): [boolean, () => void] {
  const [visible, setVisible] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const trigger = useCallback(() => {
    if (timeoutRef.current !== null) clearTimeout(timeoutRef.current);
    setVisible(true);
    timeoutRef.current = setTimeout(() => {
      setVisible(false);
      timeoutRef.current = null;
    }, durationMs);
  }, [durationMs]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current !== null) clearTimeout(timeoutRef.current);
    };
  }, []);

  return [visible, trigger];
}
